<script>

    import Vue from 'vue';
    import PhotoSwipe from 'photoswipe';
    import PhotoswipeMarkup from 'components/photoswipe/PhotoswipeMarkup';
    import PhotoswipeUI from 'components/photoswipe/PhotoswipeUI';
    import { getURLHashbangAttributes } from 'components/photoswipe/utils/utils';

    /**
     *
     */
    export default {

        props: {
            galleryId: {
                type: String,
                required: true,
            },
        },


        data() {
            return {
                markupElement: null,
                selectedImageIndex: 0,
                realViewportWidth: 0,
                isUseLargeImages: false,
                isFirstResize: true,
                isImageSrcWillChange: true,
            };
        },


        computed: {
            photoswipeItems() {
                return this.$children.map((childComponent) => {
                    return childComponent.getPhotoswipeItemConfig();
                });
            },

            photoswipeOptions() {
                return {
                    index: this.selectedImageIndex,
                    history: true,
                    galleryUID: this.galleryId,
                    showHideOpacity: true,
                    getThumbBoundsFn: this.getThumbnailBounds,
                    addCaptionHTMLFn: this.addCaptionsHtml,
                };
            },
        },


        mounted() {
            this.addMarkup();

            const urlParams = getURLHashbangAttributes();
            if (urlParams.gid === this.galleryId) {
                const index = urlParams.pid - 1;
                this.openPhotoswipe(this.$children[index]);
            }
        },


        methods: {

            /**
             * Add Photoswipe markup to body
             */
            addMarkup() {
                this.markupElement = document.querySelector('#photoswipeMarkup');
                if (!this.markupElement) {
                    const PhotoswipeMarkupComponent = Vue.extend(PhotoswipeMarkup);
                    const photoswipeMarkup = new PhotoswipeMarkupComponent().$mount();
                    document.body.appendChild(photoswipeMarkup.$el);
                    this.markupElement = photoswipeMarkup.$el;
                }
            },


            /**
             * Open the photoswipe gallery
             */
            openPhotoswipe(child) {
                this.selectedImageIndex = this.getIndexOfChild(child);
                this.$options.photoswipe = new PhotoSwipe(this.markupElement, PhotoswipeUI, this.photoswipeItems, this.photoswipeOptions);
                this.$options.photoswipe.listen('beforeResize', this.onBeforeGalleryResize);
                this.$options.photoswipe.listen('gettingData', this.onGettingImageData);
                this.$options.photoswipe.init();
            },


            /**
             *
             */
            getIndexOfChild(childComponent) {
                return this.$children.findIndex(c => c === childComponent);
            },

            /**
             *
             */
            getThumbnailBounds(index) {
                const item = this.$children[index];
                const pageYScroll = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
                if (item) {
                    const thumbnail = item.$el.querySelector('.photoswipeItem-thumbnail');
                    const rect = thumbnail ? thumbnail.getBoundingClientRect() : null;
                    return rect ? {
                        x: rect.left,
                        y: rect.top + pageYScroll,
                        w: rect.width,
                    } : null;
                }
                return null;
            },


            /**
             *
             * item      - slide object
             * captionEl - caption DOM element
             * isFake    - true when content is added to fake caption container
             *             (used to get size of next or previous caption)
             */
            addCaptionsHtml(item, captionEl, isFake) {
                const captionElContent = captionEl.querySelector('.pswp__caption__content');

                if (!captionElContent) {
                    return false;
                }

                if (!item.title) {
                    captionElContent.innerHTML = '';
                    return false;
                }

                captionElContent.innerHTML = item.title;
                return true;
            },


            /**
             *
             * gallery.viewportSize.x - width of PhotoSwipe viewport
             * gallery.viewportSize.y - height of PhotoSwipe viewport
             * window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
             *                           1 (regular display), 2 (@2x, retina) ...
             */
            onBeforeGalleryResize() {
                // calculate real pixels when size changes
                this.realViewportWidth = this.$options.photoswipe.viewportSize.x * window.devicePixelRatio;

                // Code below is needed if you want image to switch dynamically on window.resize

                // Find out if current images need to be changed (responsive images)
                if (this.isUseLargeImages && this.realViewportWidth <= 667) {
                    this.isUseLargeImages = false;
                    this.isImageSrcWillChange = true;
                } else if (!this.isUseLargeImages && this.realViewportWidth > 667) {
                    this.isUseLargeImages = true;
                    this.isImageSrcWillChange = true;
                }

                // Invalidate items only when source is changed and when it's not the first update
                if (this.isImageSrcWillChange && !this.isFirstResize) {
                    // invalidateCurrItems sets a flag on slides that are in DOM,
                    // which will force update of content (image) on window.resize.
                    this.$options.photoswipe.invalidateCurrItems();
                }

                if (this.isFirstResize) {
                    this.isFirstResize = false;
                }

                this.isImageSrcWillChange = false;
            },


            /**
             *
             */
            onGettingImageData(index, item) {
                // Set image source & size based on real viewport width
                if (this.isUseLargeImages) {
                    item.src = item.normal.src;
                    item.w = item.normal.w;
                    item.h = item.normal.h;
                } else {
                    item.src = item.mobile.src;
                    item.w = item.mobile.w;
                    item.h = item.mobile.h;
                }
            },
        },

    };
</script>

<template>
    <div class="photoswipeContainer">
        <slot />
    </div>
</template>
